import { defineFeature } from '../define-feature';
import { SEO_BACKLINK_REVIEW_PARAM, SeoSpaceTab, seoSpaceWebPath } from '../../seo/seo-space-routes';

export default defineFeature({
  id: 'marketing.seo_pack.backlinks',
  category: 'marketing',
  title: 'Le lien partenaire du mois',
  intent:
    'Obtenir chaque mois un article sur vous, publié sur un site de votre secteur avec un lien vers votre site, et choisir si vous le relisez avant publication.',
  context: {
    why: "Google accorde plus de confiance à un site vers lequel d'autres sites pointent, et les assistants IA (ChatGPT, Perplexity, mode IA de Google) recommandent plus volontiers un professionnel dont d'autres sites parlent déjà. Chaque mois, le pack fait rédiger un article sur votre activité et le fait publier sur un site partenaire de votre thématique, avec un lien vers une page de votre site (page d'accueil, prestation, article : la cible tourne pour renforcer tout le site). Le domaine hôte et la page ciblée apparaissent dans votre espace référencement dès la publication.",
    use_cases: [
      'Laisser faire : article rédigé et publié automatiquement chaque mois.',
      "Relire et retoucher l'article partenaire avant qu'il parte.",
      'Vérifier que le lien du mois est bien en ligne.',
    ],
  },
  required_scopes: ['website.seo_articles'],
  prerequisites: [
    {
      ref: 'marketing.seo_pack.overview',
      requirement: 'required',
      why: "Le mode de relecture se choisit dans le parcours de première activation ; aucun lien n'est commandé avant.",
    },
  ],
  ui_entry_points: [
    {
      route: seoSpaceWebPath(SeoSpaceTab.BACKLINKS),
      element: `Onglet « Backlinks » ; relecture ouverte par le lien de l’e-mail « Un article partenaire attend votre relecture » (paramètre « ${SEO_BACKLINK_REVIEW_PARAM} »)`,
    },
  ],
  api: {
    primary_operation_id: 'SeoContentAppController_validateBacklinkArticle',
    related_operation_ids: [
      'SeoContentAppController_backlinkArticle',
      'SeoContentAppController_pack',
      'SeoContentAppController_externalBacklinksList',
      'SeoContentAppController_saveSettings',
    ],
  },
  steps: [
    "**Choisissez qui relit l'article partenaire** (parcours d'activation, modifiable ensuite dans l'onglet Backlinks) : publication automatique, ou relecture par vous.",
    "**Du 1er au 5 de chaque mois**, le lien du mois est commandé. En mode relecture, l'article vous est soumis d'abord.",
    "**En mode relecture, validez sous 7 jours** (rappel au 3e jour) : vous pouvez retoucher le titre et le texte avant l'envoi au partenaire.",
    '**Le lien est publié dans le mois.** Il apparaît dans la liste avec le site hôte et la page de votre site qui reçoit le lien ; nous vérifions chaque jour qu’il reste en ligne.',
  ],
  gotchas: [
    "**Votre premier lien partenaire concerne le mois qui suit l'activation** : « Votre premier lien partenaire sera commandé début » suivi du mois.",
    "**En mode relecture, sans validation au bout de 7 jours le mois est perdu** : aucun lien n'est commandé pour ce mois, pas de report.",
    "**En mode automatique, l'article est figé une fois publié** chez le partenaire : c'est pour cela que ce choix vous est demandé explicitement et n'est jamais pris à votre place.",
    "**Le site partenaire n'est pas choisi par vous** : il est sélectionné dans votre thématique.",
    '**Le mode choisi vaut pour tous vos liens partenaires** : lien du pack, liens supplémentaires et accélérateur suivent le même fonctionnement, publication automatique ou relecture par vous.',
    "**Un lien qui disparaît est remplacé** quand c'est possible (statut « remplacé » dans la liste).",
    "**En mode relecture, il arrive qu'aucun article conforme ne sorte** du premier coup : la commande du mois est alors reprise à la main par notre équipe, sans action de votre part.",
  ],
  related_features: ['marketing.seo_pack.overview', 'marketing.seo_pack.options'],
});
